import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const Rewards = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <path
        d="M12.6667 6.66667H3.33335M12.6667 6.66667L13.9095 8.73793C14.188 9.20213 14.3273 9.43427 14.3995 9.68413C14.4637 9.90547 14.489 10.1363 14.4745 10.3663C14.4581 10.6259 14.3725 10.8827 14.2013 11.3963L14.0627 11.8119C13.8005 12.5987 13.6693 12.9921 13.4261 13.283C13.2113 13.5399 12.9355 13.7387 12.6239 13.8612C12.271 14 11.8563 14 11.0269 14H4.97311C4.14373 14 3.72904 14 3.37619 13.8612C3.0646 13.7387 2.78877 13.5399 2.57397 13.283C2.33074 12.9921 2.1996 12.5987 1.93733 11.8119L1.79877 11.3963C1.62758 10.8827 1.54199 10.6259 1.52559 10.3663C1.51105 10.1363 1.53639 9.90547 1.60047 9.68407C1.6728 9.43427 1.81206 9.20213 2.09058 8.73793L3.33335 6.66667M12.6667 6.66667L12.9449 5.69303C13.0767 5.23145 13.1427 5.00065 13.0909 4.81805C13.0455 4.6581 12.942 4.52088 12.8007 4.43331C12.6393 4.33333 12.3993 4.33333 11.9193 4.33333H4.0808C3.60073 4.33333 3.3607 4.33333 3.19936 4.43331C3.05803 4.52088 2.95453 4.6581 2.90915 4.81805C2.85735 5.00065 2.92329 5.23145 3.05517 5.69303L3.33335 6.66667M8 4.33333H5.64287C5.29557 4.33333 4.96249 4.19286 4.7169 3.94281C4.47132 3.69276 4.33335 3.35362 4.33335 3C4.33335 2.64638 4.47132 2.30724 4.7169 2.05719C4.96249 1.80714 5.29557 1.66667 5.64287 1.66667C7.4762 1.66667 8 4.33333 8 4.33333ZM8 4.33333H10.3571C10.7045 4.33333 11.0375 4.19286 11.2831 3.94281C11.5287 3.69276 11.6667 3.35362 11.6667 3C11.6667 2.64638 11.5287 2.30724 11.2831 2.05719C11.0375 1.80714 10.7045 1.66667 10.3571 1.66667C8.5238 1.66667 8 4.33333 8 4.33333Z"
        stroke={color}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default withStyles(Rewards);
